import axios from "axios";

const ApiGServer = axios.create({
  baseURL: process.env.REACT_APP_API_GLOBAL_SERVER,
});
export default ApiGServer;